const getAnchorLastDate = (yearMonth) => {
  if (!yearMonth) return 31;
  const [year, month] = yearMonth.split('-').map(Number);
  return new Date(year, month, 0).getDate();
};

const getPeriodDay = (dayOfMonth, yearMonth) => {
  if (!dayOfMonth || !yearMonth) return 1;
  const isAnchorMonth = dayOfMonth >= 16;
  const anchorLastDate = getAnchorLastDate(yearMonth);
  return isAnchorMonth ? dayOfMonth - 15 : (anchorLastDate - 15) + dayOfMonth;
};

const getPeriodWeek = (dayOfMonth, yearMonth) => {
  return Math.ceil(getPeriodDay(dayOfMonth, yearMonth) / 7);
};

const getDateStringForPeriod = (dayOfMonth, yearMonth) => {
  if (!yearMonth) return '';
  const [year, month] = yearMonth.split('-').map(Number);
  const isAnchorMonth = dayOfMonth >= 16;
  const targetYear = isAnchorMonth ? year : (month === 12 ? year + 1 : year);
  const targetMonth = isAnchorMonth ? month : (month === 12 ? 1 : month + 1);
  return `${targetYear}-${String(targetMonth).padStart(2, '0')}-${String(dayOfMonth).padStart(2, '0')}`;
};

export { getPeriodDay, getPeriodWeek, getDateStringForPeriod };
